/**
 * Queue calling settings (Redmine #18575, design §22). Per-branch (optionally per-room) toggles:
 * auto-call-next after a sign, and the "Mời chuẩn bị" group size. Real /api/v1/queue/settings.
 */
import { apiClient } from "./client";

export interface QueueCallSettings {
  autoCallNext: boolean;
  prepareGroupSize: number;
}

export const queueSettingsApi = {
  get(branchId: string, roomId?: string | null): Promise<QueueCallSettings> {
    return apiClient
      .get<QueueCallSettings>("/v1/queue/settings", {
        params: { branchId, roomId: roomId ?? undefined },
      })
      .then((r) => r.data);
  },
  update(
    branchId: string,
    body: QueueCallSettings,
    roomId?: string | null
  ): Promise<QueueCallSettings> {
    return apiClient
      .put<QueueCallSettings>("/v1/queue/settings", body, {
        params: { branchId, roomId: roomId ?? undefined },
      })
      .then((r) => r.data);
  },
};

export const queueSettingsQueryKeys = {
  of: (branchId: string, roomId?: string | null) =>
    ["queue-settings", branchId, roomId ?? null] as const,
};
